export function withDiscriminant(value, discriminant) {
    if (discriminant !== undefined) {
        value.discriminant = discriminant;
    }
    return value;
}
export function formatVariantName(name, discriminant) {
    return discriminant === undefined ? name : `${name} = ${discriminant}`;
}
//# sourceMappingURL=variant.js.map